<template>
  <div class="customized-pie">
    <div :id="customizedPieItemsId" :style="{width: width, height: height}" ></div>
  </div>
</template>

<script>
  export default {
    name: 'customized-pie',
    props: {
      customizedPieItemsId: {
        type: String,
        default () {
          return 'customizedPieItems'
        }
      },
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '240px'
        }
      },
      lineTitle: {
        type: String,
        default () {
          return ''
        }
      },
      titleStyle: {
        type: Object,
        default () {
          return  {}
        }
      },
      legendData: {
        type: Array,
        default () {
          return []
        }
      },
      xAxis: {
        type: Object,
        default () {
          return  {}
        }
      },
      yAxis: {
        type: Array,
        default () {
          return []
        }
      },
      series: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {}
    },
    mounted () {
      this.drawPie()
    },
    methods: {
      drawPie() {
        let customizedPieItemsId = this.$echarts.init(document.getElementById(this.customizedPieItemsId))
        customizedPieItemsId.setOption({
          title: {
            show: false,
            text: this.lineTitle,
            textStyle: this.titleStyle
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)'
          },
          visualMap: {
            show: false,
            min: 80,
            max: 600,
            inRange: {
              colorLightness: [0, 1]
            }
          },
          // legend: {
          //   right: '4%',
          //   data: this.legendData
          // },
          // color: ['#92D050', '#FFC000'],
          series: this.series
        })
      },
    },
    watch: {
      series (val) {
        this.drawPie()
      }
    }
  }
</script>

<style scoped>
  .customized-pie {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Pie/Pie/CustomizedPie.vue